(function ($) {
  //header-slider----------------------------------------------------------------------
  $(".carousel").each(function () {
    var currentCarousel = $(this);
    var carouselhammer = new Hammer(this);
    carouselhammer.on("swipeleft", function () {
      //alert('swipeleft');
      currentCarousel.carousel("next");
    });
    carouselhammer.on("swiperight", function () {
      currentCarousel.carousel("prev");
    });
  });

  //vimeo youtube responsive-----------------
  $(
    'iframe[src*="vimeo"]:not(.masonry),iframe[src*="youtube"]:not(.masonry)'
  ).wrap('<div class="video-container"></div>');

  //flickr bilder laden---------shortcode flickr-manager----------------

  $(".flickr-shortcode-image").each(function () {
    var this_el = $(this);
    //console.log("https://api.flickr.com/services/rest/?method=flickr.photos.getInfo&api_key=0d3960999475788aee64408b64563028&photo_id="+$(this).attr("id").replace(/flickr-/,'')+"&format=json&jsoncallback=?");
    $.getJSON(
      "https://api.flickr.com/services/rest/?method=flickr.photos.getInfo&api_key=0d3960999475788aee64408b64563028&photo_id=" +
        $(this)
          .attr("id")
          .replace(/flickr-/, "") +
        "&format=json&jsoncallback=?",
      function (data) {
        //console.log(data);
        if (data.stat == "ok") {
          if (this_el.parent().hasClass("header-image"))
            //header Image
            this_el.html(
              '<img src="https://farm' +
                data.photo.farm +
                ".staticflickr.com/" +
                data.photo.server +
                "/" +
                data.photo.id +
                "_" +
                data.photo.secret +
                '_b.jpg" alt="' +
                data.photo.title.description +
                '" title="' +
                data.photo.title._content +
                '" border="0" />'
            );
          else {
            this_el.html(
              '<img src="https://farm' +
                data.photo.farm +
                ".staticflickr.com/" +
                data.photo.server +
                "/" +
                data.photo.id +
                "_" +
                data.photo.secret +
                '_n.jpg" alt="' +
                data.photo.title.description +
                '" title="' +
                data.photo.title._content +
                '" border="0" />'
            );
          }
          if (data.photo.owner.path_alias == "arselectronicacenter")
            this_el.attr(
              "href",
              this_el
                .attr("href")
                .replace(/arselectronica/, "arselectronicacenter")
            );
        }
      }
    );
  });

  $(".paged-list:not(.carousel)").each(function (i) {
    var id = "carousel-paged-list-" + i;
    var carousel = $(
      '<div id="' +
        id +
        '" class="carousel slide ' +
        $(this).attr("class") +
        '" data-ride="carousel" data-interval="false"></div>'
    );
    var carouselIndicators = $('<ol class="carousel-indicators"></ol>');
    var carouselInner = $('<div class="carousel-inner"></div>');
    carousel.append([carouselIndicators, carouselInner]);

    var contentItems = $(">*", this);
    var itemsPerPage = 5;
    if (
      $(this).is("[items-per-page]") &&
      parseInt($(this).attr("items-per-page")) > 0
    ) {
      itemsPerPage = parseInt($(this).attr("items-per-page"));
    }
    pages = Math.ceil(contentItems.length / itemsPerPage);

    var ci = 0;
    for (var i = 0; i < pages; ++i) {
      var contentItem = $(
        '<div class="carousel-item"><div class="row"></div></div>'
      );
      for (var j = 0; j < itemsPerPage; ++j) {
        $(contentItems[ci++])
          .contents()
          .appendTo($(">div.row", contentItem));
      }
      carouselIndicators.append(
        $(
          '<li data-target="#' +
            id +
            '" data-slide-to="' +
            i +
            '" alt="' +
            (i + 1) +
            '"></li>'
        )
      );
      carouselInner.append(contentItem);
    }
    carouselIndicators.append(`<a class="carousel-control-prev" href="#${id}" role="button" data-slide="prev">
															<span class="carousel-control-prev-icon" aria-hidden="true"></span>
															<span class="sr-only">Zurück</span>
														</a>
														<a class="carousel-control-next" href="#${id}" role="button" data-slide="next">
															<span class="carousel-control-next-icon" aria-hidden="true"></span>
															<span class="sr-only">Weiter</span>
														</a>`);
    $(
      ".carousel-item:first-child, .carousel-indicators li:first-child",
      carousel
    ).addClass("active");
    $(this).replaceWith(carousel);
  });


  function limitMaxWords(el, maxChar = 12) {
    var str = String($(el).html());
    var words = str.split(" ");
    var result = words
      .map((word, idx) => {
        var chunkString = function (str, length) {
          return str.match(new RegExp(".{1," + length + "}", "g"));
        };

        var out = [];
        if (maxChar >= 1) {
          var wordArray = chunkString(word, maxChar); // just one under maxChar in order to add the innerword separator '-'
          if (wordArray.length > 1) {
            if (word.includes("-")) {
              return word;
            }
            // Add every piece of word but the last, concatenated with '-' at the end
            for (var i = 0; i < wordArray.length - 1; i++) {
              var piece = wordArray[i] + "-\r\n";
              out.push(piece);
            }
            if (wordArray[wordArray.length - 1].length <= 2) {
              out[out.length - 1] =
                out[out.length - 1] + wordArray[wordArray.length - 1];
              return;
            }
            // finally, add the last piece
            out.push(wordArray[wordArray.length - 1]);
          }
        }
        // If nothing done, just use the same word
        if (out.length == 0) {
          out.push(word);
        }
        return out.join("");
      })
      .join(" ");

    $(el).html(result);
  }
})(jQuery);
